import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NbAuthModule, NbDummyAuthStrategy } from '@nebular/auth';

import { throwIfAlreadyLoaded } from '../module-import-guard';
import { LayoutService } from './utils';

import { UserData } from './data/users';
import { SmartTableData } from './data/smart-table';

import { OrdersProfitChartData } from './data/orders-profit-chart';
import { OrdersChartData } from './data/orders-chart';
import { ProfitChartData } from './data/profit-chart';

import { OrdersChartService } from './mock/orders-chart.service';
import { ProfitChartService } from './mock/profit-chart.service';

import { UserService } from './mock/users.service';
import { SmartTableService } from './mock/smart-table.service';
import { MockDataModule } from './mock/mock-data.module';

import { BrowserWindowRef, WindowRef } from './utils';
import { OrdersProfitChartService } from './mock/orders-profit-chart.service';
import { DashboardChartData } from './data/dashboard-chart';
import { DashboardChartService } from './mock/dashboard-chart.service';
import { ExcelReaderService } from './services/excel-reader.service';

const DATA_SERVICES = [
  { provide: UserData, useClass: UserService },
  { provide: SmartTableData, useClass: SmartTableService },
  { provide: OrdersChartData, useClass: OrdersChartService },
  { provide: ProfitChartData, useClass: ProfitChartService },
  { provide: OrdersProfitChartData, useClass: OrdersProfitChartService},
  { provide: DashboardChartData, useClass: DashboardChartService}
];

export const NB_CORE_PROVIDERS = [
  ...MockDataModule.forRoot().providers,
  ...DATA_SERVICES,
  {
    provide: WindowRef, useClass: BrowserWindowRef,
  },
  LayoutService,
  ExcelReaderService
];

@NgModule({
  imports: [
    CommonModule,
  ],
  exports: [
    NbAuthModule,
  ],
  declarations: [],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }

  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        ...NB_CORE_PROVIDERS,
      ],
    };
  }
}
